import * as Toolkit from '../../toolkit/index';
import RenderWarning from './render';
import { onlyCenterGoodsSize } from '../goods/index';
import { makeWarningList, pieceWarningStr } from './warningData';

// 商品警告信息
export function goodsWarning(cube: FreeObjMap): void {
    let warningList: Array<string> = makeWarningList(cube);

    if (!warningList.length) {
        return;
    }

    let warningStr: string = pieceWarningStr(warningList);
    var goodSize: Size = onlyCenterGoodsSize(cube);
    let warningTxtFontSize: number = Toolkit.computeFontSize({
        continerWidth: Toolkit.cmToPx(goodSize.width),
        continerHeight: Toolkit.cmToPx(goodSize.height),
        strLength: warningStr.length,
        maxFontSize: 12
    });

    RenderWarning({
        cube,
        warningTxtFontSize,
        warningStr,
        warningList
    });
}
